import React, { useState, useEffect } from 'react';
import './css/SimpleClock.css';
import './css/SimpleClockPreview.css';
import { useSelector } from 'react-redux';

const CornerSimpleClock = ({ area, dimensions, timestamp, previewMode = false }) => {
    const [time, setTime] = useState(new Date(timestamp * 1000));
    const [showColon, setShowColon] = useState(true);
    const { clockSettings, clockDisplay } = useSelector((state) => state.apps);

    const [areaHpx, setAreaHpx] = useState();
    const [areaWpx, setAreaWpx] = useState();
    const [Corner, setCorner] = useState(false);

    useEffect(() => {
        if (previewMode) {
            if (clockDisplay == "CORNER") {
                setAreaHpx(((area.height / 100) * dimensions.height));
                setAreaWpx(((area.width / 100) * dimensions.width));
            } else {
                setAreaHpx((dimensions.height));
                setAreaWpx((dimensions.width));
            }
        } else {
            if (clockDisplay == "CORNER") {
                setAreaHpx(((area.height / 100) * dimensions.height));
                setAreaWpx(((area.width / 100) * dimensions.width));
            } else {
                setAreaHpx((dimensions.height));
                setAreaWpx((dimensions.width));
            }
        }
    }, [area]);
    useEffect(() => {
        if (clockDisplay == "CORNER") {
            setCorner(true);
        }
    }, [clockDisplay]);

    useEffect(() => {
        if (timestamp) {
            const baseTime = new Date(timestamp * 1000);
            setTime(baseTime);
        }
    }, [timestamp]);

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(prev => new Date(prev.getTime() + 1000));
            setShowColon(prev => !prev);
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const formatTime = (val) => (val < 10 ? `0${val}` : val.toString());

    const getFormattedHours = () => {
        let hours = time.getUTCHours();
        if (clockSettings.timeFormat === '12') {
            hours = hours % 12 || 12;
        }
        return formatTime(hours);
    };

    const hours = getFormattedHours();
    const minutes = formatTime(time.getMinutes());
    const dayOfWeek = time.toLocaleDateString("en-US", { weekday: "short" }).toUpperCase();
    const day = formatTime(time.getDate());


    const ClockContainer = previewMode ? 'simple-clock-container-preview' : `simple-clock-container`;


    return (
        <div
            className={`${ClockContainer} "d-flex align-items-center justify-content-center"`}
            style={{
                backgroundColor: clockDisplay == "CORNER" ? "transparent" : clockSettings.bg_color_main,
                color: clockSettings.text_color,
                fontFamily: 'monospace',
                // fontSize: previewMode ? '5rem' : "15vw",
                fontSize: `${Math.min(areaWpx * 0.16, areaHpx * 0.7)}px`,

                fontWeight: 'bold',
                gap: `${Math.min(areaWpx * 0.06, areaHpx * 0.7)}px`
            }}
        >
            <div className="d-flex" style={{ alignItems: 'baseline' }}>
                <span>{hours}</span>
                <span style={{ visibility: showColon ? 'visible' : 'hidden' }}>:</span>
                <span>{minutes}</span>
            </div>
            <div className="d-flex gap-1 flex-column justify-between align-items-start" style={{
                fontSize: `${Math.min(areaWpx * 0.05, areaHpx * 0.2)}px`,
                lineHeight: `${Math.min(areaWpx * 0.05, areaHpx * 0.2)}px`,
                fontWeight: '500'
            }}>
                <span>{dayOfWeek}</span>
                <span style={{
                    fontSize: `${Math.min(areaWpx * 0.06, areaHpx * 0.25)}px`,
                    lineHeight: `${Math.min(areaWpx * 0.06, areaHpx * 0.25)}px`

                    , fontWeight: '700'
                }}>{day}</span>
            </div>
        </div >
    );
};

export default CornerSimpleClock;
